import { Component, OnInit } from '@angular/core';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { ContestAndIncentiveDetailsService } from '../services/contest-and-incentive-details.service';
import { OfflineService } from 'src/app/offline/offline.service';
import { IncentiveDashboardSearchHandler } from './incentive-dashboard-search.handler';

@Component({
  selector: 'sym-incentive-dashboard-search',
  templateUrl: './incentive-dashboard-search.component.html',
  styleUrls: ['./incentive-dashboard-search.component.scss'],
})
export class IncentiveDashboardSearchComponent extends IncentiveDashboardSearchHandler {
  constructor(
    public agentService: ContestAndIncentiveDetailsService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public offlineService: OfflineService
  ) {
    super(agentService, headerService, router, settingService, offlineService);
  }
}
